/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    a: "a"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.h1, null, "CONTACT US"), "\n", React.createElement(_components.p, null, "Please contact Hitachi's Research and Development Group for any inquiries regarding this website."), "\n", React.createElement(_components.p, null, "URL: ", React.createElement(_components.a, {
    href: "https://www8.hitachi.co.jp/inquiry/hitachi-ltd/hqrd/rd/en/form.jsp"
  }, "https://www8.hitachi.co.jp/inquiry/hitachi-ltd/hqrd/rd/en/form.jsp")));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
